/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */
import React, { FC, useState } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { Logout, AuthPage, useAuth } from '../modules/auth'
import { ExamPage } from '../modules/profile/ExamPage'
import { App } from '../App'



/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env
const AppRoutes: FC = () => {
    const { currentUser } = useAuth()



    return (
        <BrowserRouter basename={PUBLIC_URL}>
            <Routes>
                <Route element={<App />}>
                    <Route path='error/*' element={<ErrorsPage />} />
                    <Route path='logout' element={<Logout />} />
                    {/* {currentUser ? (
                        currentUser.egeyosAttended !== "-1" && currentUser.tryosAttended !== "-1" && currentUser.surveyCompleted !== "-1" ?
                            (
                                currentUser.idUploaded === "1" && currentUser.idApproved === "1" ?
                                    (
                                        <>
                                            <Route path='/*' element={<PrivateRoutes />} />
                                            <Route index element={<Navigate to='/dashboard' />} />
                                        </>
                                    )
                                    :
                                    currentUser.cannotRegister === "1" ?
                                        (
                                            <>
                                                <Route path='exam/*' element={<ExamPage />} />
                                                <Route path='*' element={<Navigate to='/exam/cannotregister' />} />
                                            </>
                                        )
                                        :
                                        currentUser.idApproved === "0" || ((currentUser.idUploaded === "-1" || currentUser.idUploaded === undefined) && (currentUser.idApproved === "-1" || currentUser.idApproved === undefined)) ?
                                            (
                                                <>
                                                    <Route path='exam/*' element={<ExamPage />} />
                                                    <Route path='*' element={<Navigate to='/exam/uploadid' />} />
                                                </>
                                            )
                                            :
                                            (
                                                <>
                                                    <Route path='exam/*' element={<ExamPage />} />
                                                    <Route path='*' element={<Navigate to='/exam/uploadconfirmation' />} />
                                                </>
                                            )
                            )
                            : currentUser.egeyosAttended === "-1" ? (
                                <>
                                    <Route path='exam/*' element={<ExamPage />} />
                                    <Route path='*' element={<Navigate to='/exam/egeyos' />} />
                                </>
                            ) : currentUser.tryosAttended === "-1" ? (
                                <>
                                    <Route path='exam/*' element={<ExamPage />} />
                                    <Route path='*' element={<Navigate to='/exam/tryos' />} />
                                </>
                            ) : currentUser.surveyCompleted === "-1" ? (
                                <>
                                    <Route path='exam/*' element={<ExamPage />} />
                                    <Route path='*' element={<Navigate to='/exam/survey' />} />
                                </>
                            ) : (
                                <>
                                </>
                            )

                    ) : (
                        <>
                            <Route path='auth/*' element={<AuthPage />} />
                            <Route path='*' element={<Navigate to='/auth' />} />
                        </>
                    )} */}

                    {/* Egeyös kaldırıldı */}

                    {currentUser ? (
                        currentUser.tryosAttended !== "-1" && currentUser.surveyCompleted !== "-1" ?
                            (
                                currentUser.idUploaded === "1" && currentUser.idApproved === "1" ?
                                    (
                                        <>
                                            <Route path='/*' element={<PrivateRoutes />} />
                                            <Route index element={<Navigate to='/dashboard' />} />
                                        </>
                                    )
                                    :
                                    currentUser.cannotRegister === "1" ?
                                        (
                                            <>
                                                <Route path='exam/*' element={<ExamPage />} />
                                                <Route path='*' element={<Navigate to='/exam/cannotregister' />} />
                                            </>
                                        )
                                        :
                                        currentUser.idApproved === "0" || ((currentUser.idUploaded === "-1" || currentUser.idUploaded === undefined) && (currentUser.idApproved === "-1" || currentUser.idApproved === undefined)) ?
                                            (
                                                <>
                                                    <Route path='exam/*' element={<ExamPage />} />
                                                    <Route path='*' element={<Navigate to='/exam/uploadid' />} />
                                                </>
                                            )
                                            :
                                            (
                                                <>
                                                    <Route path='exam/*' element={<ExamPage />} />
                                                    <Route path='*' element={<Navigate to='/exam/uploadconfirmation' />} />
                                                </>
                                            )
                            ) : currentUser.tryosAttended === "-1" ? (
                                <>
                                    <Route path='exam/*' element={<ExamPage />} />
                                    <Route path='*' element={<Navigate to='/exam/tryos' />} />
                                </>
                            ) : currentUser.surveyCompleted === "-1" ? (
                                <>
                                    <Route path='exam/*' element={<ExamPage />} />
                                    <Route path='*' element={<Navigate to='/exam/survey' />} />
                                </>
                            ) : (
                                <>
                                </>
                            )

                    ) : (
                        <>
                            <Route path='auth/*' element={<AuthPage />} />
                            <Route path='*' element={<Navigate to='/auth' />} />
                        </>
                    )}
                </Route>
            </Routes>
        </BrowserRouter>
    )
}

export { AppRoutes }
